var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPickupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11816_294865)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.33331,
    width: 43.3688,
    height: 43.3688,
    rx: 21.6844,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0177 22.7003C27.6994 22.7003 29.0627 21.337 29.0627 19.6553C29.0627 17.9735 27.6994 16.6102 26.0177 16.6102C24.336 16.6102 22.9727 17.9735 22.9727 19.6553C22.9727 21.337 24.336 22.7003 26.0177 22.7003Z",
    stroke: "#6C757D",
    strokeWidth: 1.84548,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0177 31.8354C30.0778 27.7754 34.1378 24.1399 34.1378 19.6553C34.1378 15.1707 30.5023 11.5352 26.0177 11.5352C21.5331 11.5352 17.8976 15.1707 17.8976 19.6553C17.8976 24.1399 21.9576 27.7754 26.0177 31.8354Z",
    stroke: "#6C757D",
    strokeWidth: 1.84548,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.93309,
    y: 0.599781,
    width: 42.1692,
    height: 42.1692,
    rx: 21.0846,
    stroke: "#EAECF0",
    strokeWidth: 1.19956
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11816_294865",
    x: 0.642352,
    y: 0,
    width: 50.7507,
    height: 50.7511,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.69096
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84548
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.150694 0 0 0 0 0.361313 0 0 0 0 0.645833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11816_294865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11816_294865",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupIcon);
export default __webpack_public_path__ + "static/media/PickupIcon.62c0be6ae21540c38a9ca4d3a2f994b8.svg";
export { ForwardRef as ReactComponent };